export default {
  data: function () {
    return {
      achErrorCodes: [
        {
          code: 'R01',
          reason: 'Insufficient funds in account'
        },
        {
          code: 'R02',
          reason: 'Account is closed'
        },
        {
          code: 'R03',
          reason: 'No account on file'
        },
        {
          code: 'R04',
          reason: 'Invalid account number'
        },
        {
          code: 'R05',
          reason: 'Unauthorized debit to consumer account'
        },
        {
          code: 'R06',
          reason: 'Returned at request of ODFI'
        },
        {
          code: 'R07',
          reason: 'Authorization revoked by customer'
        },
        {
          code: 'R08',
          reason: 'Payment stopped'
        },
        {
          code: 'R09',
          reason: 'Insufficient collected funds in account being charged'
        },
        {
          code: 'R10',
          reason: 'Customer advises not Authorized, notice not provided, improper source document, or amount of entry not accurately obtained from source document'
        },
        {
          code: 'R11',
          reason: 'Check truncation return'
        },
        {
          code: 'R12',
          reason: 'Account sold to another financial institution'
        },
        {
          code: 'R13',
          reason: 'Invalid ACH routing number'
        },
        {
          code: 'R14',
          reason: 'Representative payee is deceased or cannot continue in that capacity'
        },
        {
          code: 'R15',
          reason: 'Beneficiary or account holder other than representative payee deceased'
        },
        {
          code: 'R16',
          reason: 'Account funds have been frozen'
        },
        {
          code: 'R17',
          reason: 'Item returned because of invalid data; refer to addenda from information'
        },
        {
          code: 'R18',
          reason: 'Improper effective date'
        },
        {
          code: 'R19',
          reason: 'Amount error'
        },
        {
          code: 'R20',
          reason: 'Account does not allow ACH transactions or limit for transactions has been exceeded'
        },
        {
          code: 'R21',
          reason: 'Invalid company identification'
        },
        {
          code: 'R22',
          reason: 'Invalid individual ID'
        },
        {
          code: 'R23',
          reason: 'Credit entry refused by receiver'
        },
        {
          code: 'R24',
          reason: 'Duplicate entry'
        },
        {
          code: 'R25',
          reason: 'Addenda record error'
        },
        {
          code: 'R26',
          reason: 'Mandatory field error'
        },
        {
          code: 'R27',
          reason: 'Trace number error'
        },
        {
          code: 'R28',
          reason: 'Routing/transit number check digit error'
        },
        {
          code: 'R29',
          reason: 'Corporate customer advised not authorized'
        },
        {
          code: 'R30',
          reason: 'RDFI not participant in check truncation program'
        },
        {
          code: 'R31',
          reason: 'Permissible return entry'
        },
        {
          code: 'R32',
          reason: 'RDFI non-settlement'
        },
        {
          code: 'R33',
          reason: 'Return of item'
        },
        {
          code: 'R34',
          reason: 'Limited participation ODFI'
        },
        {
          code: 'R35',
          reason: 'Return of improper debit entry'
        },
        {
          code: 'R36',
          reason: 'Return of improper credit entry'
        },
        {
          code: 'R37',
          reason: 'Source document presented for payment'
        },
        {
          code: 'R38',
          reason: 'Stop payment on source document'
        },
        {
          code: 'R39',
          reason: 'Improper source document'
        },
        {
          code: 'R40',
          reason: 'Return of item by government agency'
        },
        {
          code: 'R41',
          reason: 'invalid Transaction Code'
        },
        {
          code: 'R42',
          reason: 'Routing/transit number check digit error'
        },
        {
          code: 'R43',
          reason: 'Invalid account number'
        },
        {
          code: 'R44',
          reason: 'Invalid individual ID'
        },
        {
          code: 'R45',
          reason: 'Invalid individual name or company name'
        },
        {
          code: 'R46',
          reason: 'Invalid representative payee indicator code'
        },
        {
          code: 'R47',
          reason: 'Duplicate enrollment'
        },
        {
          code: 'R50',
          reason: 'State law affecting RCK acceptance'
        },
        {
          code: 'R51',
          reason: 'Item is ineligible, notice not provided, signature not genuine, or original item altered for adjustment entry'
        },
        {
          code: 'R52',
          reason: 'Stop payment on item'
        },
        {
          code: 'R53',
          reason: 'Item and ACH entry presented for payment'
        },
        {
          code: 'R61',
          reason: 'Misrouted return - RDFI for original entry has placed incorrect routing/transit number in RDFI identification field'
        },
        {
          code: 'R67',
          reason: 'Duplicate return'
        },
        {
          code: 'R68',
          reason: 'Untimely return - return was not sent within the established time frame'
        },
        {
          code: 'R69',
          reason: 'Field errors'
        },
        {
          code: 'R70',
          reason: 'Permissible return entry not accepted'
        },
        {
          code: 'R71',
          reason: 'Misrouted dishonored return -incorrect routing/transit number in RDFI identification field'
        },
        {
          code: 'R72',
          reason: 'Untimely return - dishonored return was not sent within the established timeframe'
        },
        {
          code: 'R73',
          reason: 'Timely original return - RDFI certifies the original return entry was sent within established timeframe for original returns'
        },
        {
          code: 'R74',
          reason: 'Corrected return - RDFI is correcting a previous return entry that was dishonored because it contained incomplete or incorrect information'
        },
        {
          code: 'R75',
          reason: 'Original return not a duplicate'
        },
        {
          code: 'R76',
          reason: 'No errors found'
        },
        {
          code: 'R80',
          reason: 'Cross-border payment coding error'
        },
        {
          code: 'R81',
          reason: 'Non-participant in cross-border program'
        },
        {
          code: 'R82',
          reason: 'Invalid foreign RDFI identification'
        },
        {
          code: 'R83',
          reason: 'Foreign RDFI unable to settle'
        },
        {
          code: 'R84',
          reason: 'Cross-border entry not processed by originating gateway operator'
        },
        {
          code: 'R94',
          reason: 'Administrative return item was processed and resubmitted as a photocopy'
        },
        {
          code: 'R95',
          reason: 'Administrative return item was processed and resubmitted as a MICR-Split'
        },
        {
          code: 'R97',
          reason: 'Administrative return item was processed and resubmitted with corrected dollar amount'
        },
        {
          code: 'R98',
          reason: 'Indicates a return PAC (pre-authorized check); RDFI provides a text reason and indicated a new account number on the PAC itself'
        },
        {
          code: 'R99',
          reason: 'Indicates a return PAC (pre-authorized check); RDFI provides a text reason on the PAC itself for which there is no equivalent return reason code'
        },
        {
          code: 'C01',
          reason: 'Incorrect account number'
        },
        {
          code: 'C02',
          reason: 'Incorrect routing/transit number'
        },
        {
          code: 'C03',
          reason: 'Incorrect routing/transit number and incorrect account number'
        },
        {
          code: 'C04',
          reason: 'Incorrect account name'
        },
        {
          code: 'C05',
          reason: 'Incorrect transaction code'
        },
        {
          code: 'C06',
          reason: 'Incorrect account number and transaction code'
        },
        {
          code: 'C07',
          reason: 'Incorrect routing/transit number, account number and transaction code'
        },
        {
          code: 'C08',
          reason: 'Incorrect foreign RDFI identification'
        },
        {
          code: 'C09',
          reason: 'Incorrect individual ID'
        },
        {
          code: 'C13',
          reason: 'Addenda format error'
        },
        {
          code: 'C61',
          reason: 'Misrouted NOC'
        },
        {
          code: 'C62',
          reason: 'Incorrect trace number'
        },
        {
          code: 'C63',
          reason: 'Incorrect company ID'
        },
        {
          code: 'C64',
          reason: 'Incorrect individual ID'
        },
        {
          code: 'C65',
          reason: 'Incorrectly formatted correct data'
        },
        {
          code: 'C66',
          reason: 'Incorrect discretionary data'
        },
        {
          code: 'C67',
          reason: 'Routing/transit number not from original entry'
        },
        {
          code: 'C68',
          reason: 'Account number not from original entry'
        },
        {
          code: 'C69',
          reason: 'Incorrect transaction code'
        },
        {
          code: 'C96',
          reason: 'Administrative return dishonor (dollar amount will be zero)'
        },
        {
          code: 'C99',
          reason: 'Converted to MICR draft (check conversion items)'
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ach.js